<app-header
  (profileChanged)="onProfileChanged($event)"
  [currentUserLabel]="currentUserLabel"
  [entityWithProfiles]="entityWithProfiles"
  [principalEntityId]="principalEntityId"
  [utilisateurConnecte]="utilisateurConnecte"
  [isUserLoaded]="isUserLoaded"
  [currentUser]="currentUser"
>
</app-header>

<mat-sidenav-container>
  @if(isUserLoaded) {
    <mat-sidenav [style.width]="sidenavWidth()" mode="side" opened>
      <app-navbar
        (toggleCollapseEvent)="handleToggleCollapse()"
        [collapsed]="collapsed()"
        [currentProfile]="currentProfile"
      >
      </app-navbar>
    </mat-sidenav>
  }
  <mat-sidenav-content [style.margin-left]="sidenavWidth()" class="content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-footer></app-footer>
